/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './create-react-component';

import { defineCosmosButton } from '@cosmos/web-scoped';
import { defineCosmosCheckbox } from '@cosmos/web-scoped';
import { defineCosmosDefaultCard } from '@cosmos/web-scoped';
import { defineCosmosIcon } from '@cosmos/web-scoped';
import { defineCosmosIcon360Photo } from '@cosmos/web-scoped';
import { defineCosmosIcon360Video } from '@cosmos/web-scoped';
import { defineCosmosIconAdd } from '@cosmos/web-scoped';
import { defineCosmosIconAirplay } from '@cosmos/web-scoped';
import { defineCosmosIconAlignCenter } from '@cosmos/web-scoped';
import { defineCosmosIconAlignLeft } from '@cosmos/web-scoped';
import { defineCosmosIconAlignRight } from '@cosmos/web-scoped';
import { defineCosmosIconAmazonMusic } from '@cosmos/web-scoped';
import { defineCosmosIconApple } from '@cosmos/web-scoped';
import { defineCosmosIconApplePodcasts } from '@cosmos/web-scoped';
import { defineCosmosIconAr } from '@cosmos/web-scoped';
import { defineCosmosIconArActive } from '@cosmos/web-scoped';
import { defineCosmosIconArLabel } from '@cosmos/web-scoped';
import { defineCosmosIconArMobile } from '@cosmos/web-scoped';
import { defineCosmosIconArchive } from '@cosmos/web-scoped';
import { defineCosmosIconArrowDown } from '@cosmos/web-scoped';
import { defineCosmosIconArrowLeft } from '@cosmos/web-scoped';
import { defineCosmosIconArrowRight } from '@cosmos/web-scoped';
import { defineCosmosIconArrowUp } from '@cosmos/web-scoped';
import { defineCosmosIconAuthor } from '@cosmos/web-scoped';
import { defineCosmosIconBack } from '@cosmos/web-scoped';
import { defineCosmosIconBack10 } from '@cosmos/web-scoped';
import { defineCosmosIconBack15 } from '@cosmos/web-scoped';
import { defineCosmosIconBack20 } from '@cosmos/web-scoped';
import { defineCosmosIconBackward } from '@cosmos/web-scoped';
import { defineCosmosIconBandsintown } from '@cosmos/web-scoped';
import { defineCosmosIconBaseballCap } from '@cosmos/web-scoped';
import { defineCosmosIconBookmark } from '@cosmos/web-scoped';
import { defineCosmosIconBookmarkFilled } from '@cosmos/web-scoped';
import { defineCosmosIconBrowse } from '@cosmos/web-scoped';
import { defineCosmosIconBrowseFilled } from '@cosmos/web-scoped';
import { defineCosmosIconBulb } from '@cosmos/web-scoped';
import { defineCosmosIconBulbFilled } from '@cosmos/web-scoped';
import { defineCosmosIconBuyTickets } from '@cosmos/web-scoped';
import { defineCosmosIconCalendar } from '@cosmos/web-scoped';
import { defineCosmosIconCalendarFilled } from '@cosmos/web-scoped';
import { defineCosmosIconCan } from '@cosmos/web-scoped';
import { defineCosmosIconCanInverted } from '@cosmos/web-scoped';
import { defineCosmosIconCancel } from '@cosmos/web-scoped';
import { defineCosmosIconCaptions } from '@cosmos/web-scoped';
import { defineCosmosIconCaptionsFilled } from '@cosmos/web-scoped';
import { defineCosmosIconCheckboxChecked } from '@cosmos/web-scoped';
import { defineCosmosIconCheckboxUnchecked } from '@cosmos/web-scoped';
import { defineCosmosIconCheckmark } from '@cosmos/web-scoped';
import { defineCosmosIconCheckout } from '@cosmos/web-scoped';
import { defineCosmosIconChromecast } from '@cosmos/web-scoped';
import { defineCosmosIconChromecastFilled } from '@cosmos/web-scoped';
import { defineCosmosIconClear } from '@cosmos/web-scoped';
import { defineCosmosIconClip } from '@cosmos/web-scoped';
import { defineCosmosIconClock } from '@cosmos/web-scoped';
import { defineCosmosIconClose } from '@cosmos/web-scoped';
import { defineCosmosIconCloseSmall } from '@cosmos/web-scoped';
import { defineCosmosIconCodeBlock } from '@cosmos/web-scoped';
import { defineCosmosIconComment } from '@cosmos/web-scoped';
import { defineCosmosIconContextual } from '@cosmos/web-scoped';
import { defineCosmosIconCopyLink } from '@cosmos/web-scoped';
import { defineCosmosIconCountry } from '@cosmos/web-scoped';
import { defineCosmosIconCrashed } from '@cosmos/web-scoped';
import { defineCosmosIconCreate } from '@cosmos/web-scoped';
import { defineCosmosIconCurrency } from '@cosmos/web-scoped';
import { defineCosmosIconCurrentlyWatching } from '@cosmos/web-scoped';
import { defineCosmosIconCut } from '@cosmos/web-scoped';
import { defineCosmosIconDeezer } from '@cosmos/web-scoped';
import { defineCosmosIconDelete } from '@cosmos/web-scoped';
import { defineCosmosIconDelivery } from '@cosmos/web-scoped';
import { defineCosmosIconDesktop } from '@cosmos/web-scoped';
import { defineCosmosIconDevices } from '@cosmos/web-scoped';
import { defineCosmosIconDirections } from '@cosmos/web-scoped';
import { defineCosmosIconDiscover } from '@cosmos/web-scoped';
import { defineCosmosIconDownload } from '@cosmos/web-scoped';
import { defineCosmosIconDownloading } from '@cosmos/web-scoped';
import { defineCosmosIconDrink } from '@cosmos/web-scoped';
import { defineCosmosIconDuplicate } from '@cosmos/web-scoped';
import { defineCosmosIconEdit } from '@cosmos/web-scoped';
import { defineCosmosIconEmail } from '@cosmos/web-scoped';
import { defineCosmosIconEpg } from '@cosmos/web-scoped';
import { defineCosmosIconEpisode } from '@cosmos/web-scoped';
import { defineCosmosIconErrorFilled } from '@cosmos/web-scoped';
import { defineCosmosIconEvent } from '@cosmos/web-scoped';
import { defineCosmosIconEventDetails } from '@cosmos/web-scoped';
import { defineCosmosIconEventEnd } from '@cosmos/web-scoped';
import { defineCosmosIconEventStart } from '@cosmos/web-scoped';
import { defineCosmosIconExpandLess } from '@cosmos/web-scoped';
import { defineCosmosIconExpandMore } from '@cosmos/web-scoped';
import { defineCosmosIconExternalLink } from '@cosmos/web-scoped';
import { defineCosmosIconFastCheckout } from '@cosmos/web-scoped';
import { defineCosmosIconFastForward } from '@cosmos/web-scoped';
import { defineCosmosIconFastRewind } from '@cosmos/web-scoped';
import { defineCosmosIconFeatureFilm } from '@cosmos/web-scoped';
import { defineCosmosIconFeedback } from '@cosmos/web-scoped';
import { defineCosmosIconFeedbackFilled } from '@cosmos/web-scoped';
import { defineCosmosIconFemale } from '@cosmos/web-scoped';
import { defineCosmosIconFileDownload } from '@cosmos/web-scoped';
import { defineCosmosIconFileRemove } from '@cosmos/web-scoped';
import { defineCosmosIconFileUpload } from '@cosmos/web-scoped';
import { defineCosmosIconFilmCamera } from '@cosmos/web-scoped';
import { defineCosmosIconFilms } from '@cosmos/web-scoped';
import { defineCosmosIconFilter } from '@cosmos/web-scoped';
import { defineCosmosIconFilterList } from '@cosmos/web-scoped';
import { defineCosmosIconFlag } from '@cosmos/web-scoped';
import { defineCosmosIconFolder } from '@cosmos/web-scoped';
import { defineCosmosIconFolderAdd } from '@cosmos/web-scoped';
import { defineCosmosIconFolderOpen } from '@cosmos/web-scoped';
import { defineCosmosIconFolderRemove } from '@cosmos/web-scoped';
import { defineCosmosIconFolderShared } from '@cosmos/web-scoped';
import { defineCosmosIconFormatBold } from '@cosmos/web-scoped';
import { defineCosmosIconFormatListNumbered } from '@cosmos/web-scoped';
import { defineCosmosIconFormatQuote } from '@cosmos/web-scoped';
import { defineCosmosIconFormatSize } from '@cosmos/web-scoped';
import { defineCosmosIconFormatUnderline } from '@cosmos/web-scoped';
import { defineCosmosIconForward } from '@cosmos/web-scoped';
import { defineCosmosIconForward10 } from '@cosmos/web-scoped';
import { defineCosmosIconForward15 } from '@cosmos/web-scoped';
import { defineCosmosIconForward20 } from '@cosmos/web-scoped';
import { defineCosmosIconFullscreen } from '@cosmos/web-scoped';
import { defineCosmosIconFullscreenExit } from '@cosmos/web-scoped';
import { defineCosmosIconGame } from '@cosmos/web-scoped';
import { defineCosmosIconGenericContent } from '@cosmos/web-scoped';
import { defineCosmosIconGooglePlay } from '@cosmos/web-scoped';
import { defineCosmosIconGooglePodcasts } from '@cosmos/web-scoped';
import { defineCosmosIconGrid } from '@cosmos/web-scoped';
import { defineCosmosIconGridLive } from '@cosmos/web-scoped';
import { defineCosmosIconHeadphones } from '@cosmos/web-scoped';
import { defineCosmosIconHeart } from '@cosmos/web-scoped';
import { defineCosmosIconHeartFilled } from '@cosmos/web-scoped';
import { defineCosmosIconHighlights } from '@cosmos/web-scoped';
import { defineCosmosIconHistory } from '@cosmos/web-scoped';
import { defineCosmosIconHome } from '@cosmos/web-scoped';
import { defineCosmosIconHomeFilled } from '@cosmos/web-scoped';
import { defineCosmosIconHot } from '@cosmos/web-scoped';
import { defineCosmosIconHourglassEmpty } from '@cosmos/web-scoped';
import { defineCosmosIconHourglassFull } from '@cosmos/web-scoped';
import { defineCosmosIconImage } from '@cosmos/web-scoped';
import { defineCosmosIconImageGallery } from '@cosmos/web-scoped';
import { defineCosmosIconInfo } from '@cosmos/web-scoped';
import { defineCosmosIconInfoHeatAnalyser } from '@cosmos/web-scoped';
import { defineCosmosIconInfographic } from '@cosmos/web-scoped';
import { defineCosmosIconInstagram } from '@cosmos/web-scoped';
import { defineCosmosIconInterview } from '@cosmos/web-scoped';
import { defineCosmosIconInvoice } from '@cosmos/web-scoped';
import { defineCosmosIconKeyboard } from '@cosmos/web-scoped';
import { defineCosmosIconLabel } from '@cosmos/web-scoped';
import { defineCosmosIconLanguage } from '@cosmos/web-scoped';
import { defineCosmosIconLaptop } from '@cosmos/web-scoped';
import { defineCosmosIconLaunch } from '@cosmos/web-scoped';
import { defineCosmosIconLink } from '@cosmos/web-scoped';
import { defineCosmosIconList } from '@cosmos/web-scoped';
import { defineCosmosIconLive } from '@cosmos/web-scoped';
import { defineCosmosIconLiveBroadcast } from '@cosmos/web-scoped';
import { defineCosmosIconLoading } from '@cosmos/web-scoped';
import { defineCosmosIconLocation } from '@cosmos/web-scoped';
import { defineCosmosIconLockFilled } from '@cosmos/web-scoped';
import { defineCosmosIconLockOpen } from '@cosmos/web-scoped';
import { defineCosmosIconMale } from '@cosmos/web-scoped';
import { defineCosmosIconMap } from '@cosmos/web-scoped';
import { defineCosmosIconMegaphone } from '@cosmos/web-scoped';
import { defineCosmosIconMenu } from '@cosmos/web-scoped';
import { defineCosmosIconMenuNotification } from '@cosmos/web-scoped';
import { defineCosmosIconMenuPulsating } from '@cosmos/web-scoped';
import { defineCosmosIconMinus } from '@cosmos/web-scoped';
import { defineCosmosIconMixer } from '@cosmos/web-scoped';
import { defineCosmosIconMore } from '@cosmos/web-scoped';
import { defineCosmosIconMouse } from '@cosmos/web-scoped';
import { defineCosmosIconMultiLanguage } from '@cosmos/web-scoped';
import { defineCosmosIconMute } from '@cosmos/web-scoped';
import { defineCosmosIconMyLocation } from '@cosmos/web-scoped';
import { defineCosmosIconNews } from '@cosmos/web-scoped';
import { defineCosmosIconNoData } from '@cosmos/web-scoped';
import { defineCosmosIconPagination } from '@cosmos/web-scoped';
import { defineCosmosIconPaginationFilled } from '@cosmos/web-scoped';
import { defineCosmosIconParcel } from '@cosmos/web-scoped';
import { defineCosmosIconPartnerProfile } from '@cosmos/web-scoped';
import { defineCosmosIconPaste } from '@cosmos/web-scoped';
import { defineCosmosIconPause } from '@cosmos/web-scoped';
import { defineCosmosIconPayment } from '@cosmos/web-scoped';
import { defineCosmosIconPersonFollow } from '@cosmos/web-scoped';
import { defineCosmosIconPersonFollowing } from '@cosmos/web-scoped';
import { defineCosmosIconPersonProfileFilled } from '@cosmos/web-scoped';
import { defineCosmosIconPhone } from '@cosmos/web-scoped';
import { defineCosmosIconPhotoCamera } from '@cosmos/web-scoped';
import { defineCosmosIconPhotoCameraReverse } from '@cosmos/web-scoped';
import { defineCosmosIconPictureInPicture } from '@cosmos/web-scoped';
import { defineCosmosIconPinterest } from '@cosmos/web-scoped';
import { defineCosmosIconPlay } from '@cosmos/web-scoped';
import { defineCosmosIconPlaylist } from '@cosmos/web-scoped';
import { defineCosmosIconPlaylistPersonalised } from '@cosmos/web-scoped';
import { defineCosmosIconPlus } from '@cosmos/web-scoped';
import { defineCosmosIconPodcast } from '@cosmos/web-scoped';
import { defineCosmosIconPresentation } from '@cosmos/web-scoped';
import { defineCosmosIconPreview } from '@cosmos/web-scoped';
import { defineCosmosIconPreviewFilled } from '@cosmos/web-scoped';
import { defineCosmosIconPreviewOff } from '@cosmos/web-scoped';
import { defineCosmosIconProductPlacement } from '@cosmos/web-scoped';
import { defineCosmosIconQuality } from '@cosmos/web-scoped';
import { defineCosmosIconQuiz } from '@cosmos/web-scoped';
import { defineCosmosIconRadioButton } from '@cosmos/web-scoped';
import { defineCosmosIconRedeem } from '@cosmos/web-scoped';
import { defineCosmosIconRedo } from '@cosmos/web-scoped';
import { defineCosmosIconReload } from '@cosmos/web-scoped';
import { defineCosmosIconReminderFalse } from '@cosmos/web-scoped';
import { defineCosmosIconReminderTrue } from '@cosmos/web-scoped';
import { defineCosmosIconRemove } from '@cosmos/web-scoped';
import { defineCosmosIconRendition } from '@cosmos/web-scoped';
import { defineCosmosIconReplay } from '@cosmos/web-scoped';
import { defineCosmosIconReplay30 } from '@cosmos/web-scoped';
import { defineCosmosIconReplay5 } from '@cosmos/web-scoped';
import { defineCosmosIconReport } from '@cosmos/web-scoped';
import { defineCosmosIconResults } from '@cosmos/web-scoped';
import { defineCosmosIconRokuReplay } from '@cosmos/web-scoped';
import { defineCosmosIconRules } from '@cosmos/web-scoped';
import { defineCosmosIconSave } from '@cosmos/web-scoped';
import { defineCosmosIconSaveFalse } from '@cosmos/web-scoped';
import { defineCosmosIconSaveTrue } from '@cosmos/web-scoped';
import { defineCosmosIconScreenRotation } from '@cosmos/web-scoped';
import { defineCosmosIconSearch } from '@cosmos/web-scoped';
import { defineCosmosIconSeason } from '@cosmos/web-scoped';
import { defineCosmosIconSecure } from '@cosmos/web-scoped';
import { defineCosmosIconSelectAll } from '@cosmos/web-scoped';
import { defineCosmosIconSettings } from '@cosmos/web-scoped';
import { defineCosmosIconShare } from '@cosmos/web-scoped';
import { defineCosmosIconShareFacebook } from '@cosmos/web-scoped';
import { defineCosmosIconShareMessenger } from '@cosmos/web-scoped';
import { defineCosmosIconShareReddit } from '@cosmos/web-scoped';
import { defineCosmosIconShareTab } from '@cosmos/web-scoped';
import { defineCosmosIconShareTwitterFilled } from '@cosmos/web-scoped';
import { defineCosmosIconShareVk } from '@cosmos/web-scoped';
import { defineCosmosIconShareWhatsapp } from '@cosmos/web-scoped';
import { defineCosmosIconShop } from '@cosmos/web-scoped';
import { defineCosmosIconShoppingBag } from '@cosmos/web-scoped';
import { defineCosmosIconShow } from '@cosmos/web-scoped';
import { defineCosmosIconSidebarOff } from '@cosmos/web-scoped';
import { defineCosmosIconSidebarOn } from '@cosmos/web-scoped';
import { defineCosmosIconSignUp } from '@cosmos/web-scoped';
import { defineCosmosIconSizeContract } from '@cosmos/web-scoped';
import { defineCosmosIconSizeExpand } from '@cosmos/web-scoped';
import { defineCosmosIconSkipNext } from '@cosmos/web-scoped';
import { defineCosmosIconSkipPrevious } from '@cosmos/web-scoped';
import { defineCosmosIconSnapchat } from '@cosmos/web-scoped';
import { defineCosmosIconSneaker } from '@cosmos/web-scoped';
import { defineCosmosIconSongkick } from '@cosmos/web-scoped';
import { defineCosmosIconSortAZ } from '@cosmos/web-scoped';
import { defineCosmosIconSortZA } from '@cosmos/web-scoped';
import { defineCosmosIconSoundcloud } from '@cosmos/web-scoped';
import { defineCosmosIconSpotify } from '@cosmos/web-scoped';
import { defineCosmosIconStar } from '@cosmos/web-scoped';
import { defineCosmosIconStarFilled } from '@cosmos/web-scoped';
import { defineCosmosIconStarred } from '@cosmos/web-scoped';
import { defineCosmosIconStarredFilled } from '@cosmos/web-scoped';
import { defineCosmosIconStart } from '@cosmos/web-scoped';
import { defineCosmosIconStop } from '@cosmos/web-scoped';
import { defineCosmosIconStory } from '@cosmos/web-scoped';
import { defineCosmosIconStrava } from '@cosmos/web-scoped';
import { defineCosmosIconSubmit } from '@cosmos/web-scoped';
import { defineCosmosIconSubtitles } from '@cosmos/web-scoped';
import { defineCosmosIconSubtitlesFilled } from '@cosmos/web-scoped';
import { defineCosmosIconSuccess } from '@cosmos/web-scoped';
import { defineCosmosIconTShirt } from '@cosmos/web-scoped';
import { defineCosmosIconTablet } from '@cosmos/web-scoped';
import { defineCosmosIconTeam } from '@cosmos/web-scoped';
import { defineCosmosIconTextFormat } from '@cosmos/web-scoped';
import { defineCosmosIconThumbsDown } from '@cosmos/web-scoped';
import { defineCosmosIconThumbsUp } from '@cosmos/web-scoped';
import { defineCosmosIconTiktok } from '@cosmos/web-scoped';
import { defineCosmosIconTiktokDark } from '@cosmos/web-scoped';
import { defineCosmosIconTiktokLight } from '@cosmos/web-scoped';
import { defineCosmosIconTrailer } from '@cosmos/web-scoped';
import { defineCosmosIconTrending } from '@cosmos/web-scoped';
import { defineCosmosIconTrophy } from '@cosmos/web-scoped';
import { defineCosmosIconTv } from '@cosmos/web-scoped';
import { defineCosmosIconTwitch } from '@cosmos/web-scoped';
import { defineCosmosIconUpload } from '@cosmos/web-scoped';
import { defineCosmosIconUser } from '@cosmos/web-scoped';
import { defineCosmosIconUserFilled } from '@cosmos/web-scoped';
import { defineCosmosIconUserSettings } from '@cosmos/web-scoped';
import { defineCosmosIconVerified } from '@cosmos/web-scoped';
import { defineCosmosIconVideo } from '@cosmos/web-scoped';
import { defineCosmosIconViewMore } from '@cosmos/web-scoped';
import { defineCosmosIconVimeo } from '@cosmos/web-scoped';
import { defineCosmosIconVine } from '@cosmos/web-scoped';
import { defineCosmosIconVolume } from '@cosmos/web-scoped';
import { defineCosmosIconVolumeDown } from '@cosmos/web-scoped';
import { defineCosmosIconVolumeLow } from '@cosmos/web-scoped';
import { defineCosmosIconVolumeMid } from '@cosmos/web-scoped';
import { defineCosmosIconVolumeUp } from '@cosmos/web-scoped';
import { defineCosmosIconVote } from '@cosmos/web-scoped';
import { defineCosmosIconVr } from '@cosmos/web-scoped';
import { defineCosmosIconWarehouse } from '@cosmos/web-scoped';
import { defineCosmosIconWarning } from '@cosmos/web-scoped';
import { defineCosmosIconWashout } from '@cosmos/web-scoped';
import { defineCosmosIconWatch } from '@cosmos/web-scoped';
import { defineCosmosIconYoutube } from '@cosmos/web-scoped';
import { defineCosmosIconZoomIn } from '@cosmos/web-scoped';
import { defineCosmosIconZoomOut } from '@cosmos/web-scoped';
import { defineCosmosImage } from '@cosmos/web-scoped';
import { defineCosmosLink } from '@cosmos/web-scoped';
import { defineCosmosMediaPreview } from '@cosmos/web-scoped';
import { defineCosmosMode } from '@cosmos/web-scoped';
import { defineCosmosPersonCard } from '@cosmos/web-scoped';
import { defineCosmosProductCard } from '@cosmos/web-scoped';
import { defineCosmosRadio } from '@cosmos/web-scoped';
import { defineCosmosSpinner } from '@cosmos/web-scoped';
import { defineCosmosStoryCard } from '@cosmos/web-scoped';
import { defineCosmosText } from '@cosmos/web-scoped';
import { defineCosmosTitle } from '@cosmos/web-scoped';
import { defineCosmosTooltip } from '@cosmos/web-scoped';
import { defineCosmosVideoCard } from '@cosmos/web-scoped';

export const CosmosButton = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-button-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosButton
});
export const CosmosCheckbox = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-checkbox-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosCheckbox
});
export const CosmosDefaultCard = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-default-card-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosDefaultCard
});
export const CosmosIcon = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIcon
});
export const CosmosIcon360Photo = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon360-photo-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIcon360Photo
});
export const CosmosIcon360Video = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon360-video-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIcon360Video
});
export const CosmosIconAdd = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-add-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconAdd
});
export const CosmosIconAirplay = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-airplay-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconAirplay
});
export const CosmosIconAlignCenter = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-align-center-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconAlignCenter
});
export const CosmosIconAlignLeft = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-align-left-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconAlignLeft
});
export const CosmosIconAlignRight = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-align-right-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconAlignRight
});
export const CosmosIconAmazonMusic = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-amazon-music-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconAmazonMusic
});
export const CosmosIconApple = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-apple-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconApple
});
export const CosmosIconApplePodcasts = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-apple-podcasts-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconApplePodcasts
});
export const CosmosIconAr = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-ar-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconAr
});
export const CosmosIconArActive = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-ar-active-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconArActive
});
export const CosmosIconArLabel = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-ar-label-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconArLabel
});
export const CosmosIconArMobile = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-ar-mobile-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconArMobile
});
export const CosmosIconArchive = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-archive-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconArchive
});
export const CosmosIconArrowDown = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-arrow-down-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconArrowDown
});
export const CosmosIconArrowLeft = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-arrow-left-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconArrowLeft
});
export const CosmosIconArrowRight = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-arrow-right-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconArrowRight
});
export const CosmosIconArrowUp = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-arrow-up-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconArrowUp
});
export const CosmosIconAuthor = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-author-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconAuthor
});
export const CosmosIconBack = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-back-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconBack
});
export const CosmosIconBack10 = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-back10-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconBack10
});
export const CosmosIconBack15 = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-back15-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconBack15
});
export const CosmosIconBack20 = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-back20-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconBack20
});
export const CosmosIconBackward = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-backward-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconBackward
});
export const CosmosIconBandsintown = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-bandsintown-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconBandsintown
});
export const CosmosIconBaseballCap = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-baseball-cap-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconBaseballCap
});
export const CosmosIconBookmark = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-bookmark-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconBookmark
});
export const CosmosIconBookmarkFilled = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-bookmark-filled-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconBookmarkFilled
});
export const CosmosIconBrowse = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-browse-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconBrowse
});
export const CosmosIconBrowseFilled = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-browse-filled-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconBrowseFilled
});
export const CosmosIconBulb = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-bulb-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconBulb
});
export const CosmosIconBulbFilled = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-bulb-filled-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconBulbFilled
});
export const CosmosIconBuyTickets = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-buy-tickets-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconBuyTickets
});
export const CosmosIconCalendar = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-calendar-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconCalendar
});
export const CosmosIconCalendarFilled = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-calendar-filled-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconCalendarFilled
});
export const CosmosIconCan = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-can-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconCan
});
export const CosmosIconCanInverted = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-can-inverted-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconCanInverted
});
export const CosmosIconCancel = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-cancel-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconCancel
});
export const CosmosIconCaptions = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-captions-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconCaptions
});
export const CosmosIconCaptionsFilled = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-captions-filled-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconCaptionsFilled
});
export const CosmosIconCheckboxChecked = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-checkbox-checked-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconCheckboxChecked
});
export const CosmosIconCheckboxUnchecked = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-checkbox-unchecked-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconCheckboxUnchecked
});
export const CosmosIconCheckmark = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-checkmark-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconCheckmark
});
export const CosmosIconCheckout = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-checkout-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconCheckout
});
export const CosmosIconChromecast = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-chromecast-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconChromecast
});
export const CosmosIconChromecastFilled = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-chromecast-filled-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconChromecastFilled
});
export const CosmosIconClear = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-clear-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconClear
});
export const CosmosIconClip = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-clip-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconClip
});
export const CosmosIconClock = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-clock-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconClock
});
export const CosmosIconClose = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-close-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconClose
});
export const CosmosIconCloseSmall = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-close-small-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconCloseSmall
});
export const CosmosIconCodeBlock = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-code-block-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconCodeBlock
});
export const CosmosIconComment = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-comment-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconComment
});
export const CosmosIconContextual = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-contextual-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconContextual
});
export const CosmosIconCopyLink = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-copy-link-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconCopyLink
});
export const CosmosIconCountry = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-country-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconCountry
});
export const CosmosIconCrashed = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-crashed-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconCrashed
});
export const CosmosIconCreate = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-create-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconCreate
});
export const CosmosIconCurrency = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-currency-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconCurrency
});
export const CosmosIconCurrentlyWatching = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-currently-watching-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconCurrentlyWatching
});
export const CosmosIconCut = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-cut-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconCut
});
export const CosmosIconDeezer = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-deezer-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconDeezer
});
export const CosmosIconDelete = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-delete-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconDelete
});
export const CosmosIconDelivery = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-delivery-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconDelivery
});
export const CosmosIconDesktop = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-desktop-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconDesktop
});
export const CosmosIconDevices = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-devices-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconDevices
});
export const CosmosIconDirections = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-directions-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconDirections
});
export const CosmosIconDiscover = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-discover-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconDiscover
});
export const CosmosIconDownload = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-download-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconDownload
});
export const CosmosIconDownloading = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-downloading-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconDownloading
});
export const CosmosIconDrink = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-drink-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconDrink
});
export const CosmosIconDuplicate = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-duplicate-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconDuplicate
});
export const CosmosIconEdit = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-edit-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconEdit
});
export const CosmosIconEmail = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-email-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconEmail
});
export const CosmosIconEpg = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-epg-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconEpg
});
export const CosmosIconEpisode = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-episode-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconEpisode
});
export const CosmosIconErrorFilled = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-error-filled-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconErrorFilled
});
export const CosmosIconEvent = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-event-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconEvent
});
export const CosmosIconEventDetails = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-event-details-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconEventDetails
});
export const CosmosIconEventEnd = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-event-end-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconEventEnd
});
export const CosmosIconEventStart = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-event-start-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconEventStart
});
export const CosmosIconExpandLess = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-expand-less-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconExpandLess
});
export const CosmosIconExpandMore = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-expand-more-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconExpandMore
});
export const CosmosIconExternalLink = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-external-link-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconExternalLink
});
export const CosmosIconFastCheckout = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-fast-checkout-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconFastCheckout
});
export const CosmosIconFastForward = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-fast-forward-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconFastForward
});
export const CosmosIconFastRewind = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-fast-rewind-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconFastRewind
});
export const CosmosIconFeatureFilm = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-feature-film-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconFeatureFilm
});
export const CosmosIconFeedback = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-feedback-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconFeedback
});
export const CosmosIconFeedbackFilled = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-feedback-filled-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconFeedbackFilled
});
export const CosmosIconFemale = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-female-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconFemale
});
export const CosmosIconFileDownload = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-file-download-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconFileDownload
});
export const CosmosIconFileRemove = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-file-remove-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconFileRemove
});
export const CosmosIconFileUpload = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-file-upload-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconFileUpload
});
export const CosmosIconFilmCamera = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-film-camera-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconFilmCamera
});
export const CosmosIconFilms = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-films-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconFilms
});
export const CosmosIconFilter = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-filter-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconFilter
});
export const CosmosIconFilterList = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-filter-list-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconFilterList
});
export const CosmosIconFlag = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-flag-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconFlag
});
export const CosmosIconFolder = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-folder-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconFolder
});
export const CosmosIconFolderAdd = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-folder-add-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconFolderAdd
});
export const CosmosIconFolderOpen = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-folder-open-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconFolderOpen
});
export const CosmosIconFolderRemove = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-folder-remove-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconFolderRemove
});
export const CosmosIconFolderShared = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-folder-shared-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconFolderShared
});
export const CosmosIconFormatBold = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-format-bold-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconFormatBold
});
export const CosmosIconFormatListNumbered = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-format-list-numbered-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconFormatListNumbered
});
export const CosmosIconFormatQuote = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-format-quote-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconFormatQuote
});
export const CosmosIconFormatSize = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-format-size-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconFormatSize
});
export const CosmosIconFormatUnderline = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-format-underline-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconFormatUnderline
});
export const CosmosIconForward = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-forward-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconForward
});
export const CosmosIconForward10 = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-forward10-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconForward10
});
export const CosmosIconForward15 = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-forward15-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconForward15
});
export const CosmosIconForward20 = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-forward20-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconForward20
});
export const CosmosIconFullscreen = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-fullscreen-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconFullscreen
});
export const CosmosIconFullscreenExit = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-fullscreen-exit-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconFullscreenExit
});
export const CosmosIconGame = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-game-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconGame
});
export const CosmosIconGenericContent = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-generic-content-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconGenericContent
});
export const CosmosIconGooglePlay = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-google-play-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconGooglePlay
});
export const CosmosIconGooglePodcasts = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-google-podcasts-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconGooglePodcasts
});
export const CosmosIconGrid = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-grid-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconGrid
});
export const CosmosIconGridLive = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-grid-live-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconGridLive
});
export const CosmosIconHeadphones = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-headphones-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconHeadphones
});
export const CosmosIconHeart = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-heart-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconHeart
});
export const CosmosIconHeartFilled = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-heart-filled-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconHeartFilled
});
export const CosmosIconHighlights = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-highlights-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconHighlights
});
export const CosmosIconHistory = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-history-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconHistory
});
export const CosmosIconHome = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-home-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconHome
});
export const CosmosIconHomeFilled = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-home-filled-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconHomeFilled
});
export const CosmosIconHot = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-hot-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconHot
});
export const CosmosIconHourglassEmpty = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-hourglass-empty-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconHourglassEmpty
});
export const CosmosIconHourglassFull = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-hourglass-full-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconHourglassFull
});
export const CosmosIconImage = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-image-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconImage
});
export const CosmosIconImageGallery = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-image-gallery-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconImageGallery
});
export const CosmosIconInfo = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-info-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconInfo
});
export const CosmosIconInfoHeatAnalyser = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-info-heat-analyser-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconInfoHeatAnalyser
});
export const CosmosIconInfographic = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-infographic-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconInfographic
});
export const CosmosIconInstagram = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-instagram-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconInstagram
});
export const CosmosIconInterview = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-interview-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconInterview
});
export const CosmosIconInvoice = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-invoice-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconInvoice
});
export const CosmosIconKeyboard = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-keyboard-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconKeyboard
});
export const CosmosIconLabel = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-label-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconLabel
});
export const CosmosIconLanguage = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-language-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconLanguage
});
export const CosmosIconLaptop = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-laptop-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconLaptop
});
export const CosmosIconLaunch = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-launch-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconLaunch
});
export const CosmosIconLink = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-link-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconLink
});
export const CosmosIconList = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-list-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconList
});
export const CosmosIconLive = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-live-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconLive
});
export const CosmosIconLiveBroadcast = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-live-broadcast-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconLiveBroadcast
});
export const CosmosIconLoading = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-loading-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconLoading
});
export const CosmosIconLocation = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-location-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconLocation
});
export const CosmosIconLockFilled = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-lock-filled-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconLockFilled
});
export const CosmosIconLockOpen = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-lock-open-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconLockOpen
});
export const CosmosIconMale = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-male-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconMale
});
export const CosmosIconMap = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-map-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconMap
});
export const CosmosIconMegaphone = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-megaphone-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconMegaphone
});
export const CosmosIconMenu = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-menu-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconMenu
});
export const CosmosIconMenuNotification = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-menu-notification-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconMenuNotification
});
export const CosmosIconMenuPulsating = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-menu-pulsating-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconMenuPulsating
});
export const CosmosIconMinus = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-minus-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconMinus
});
export const CosmosIconMixer = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-mixer-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconMixer
});
export const CosmosIconMore = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-more-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconMore
});
export const CosmosIconMouse = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-mouse-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconMouse
});
export const CosmosIconMultiLanguage = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-multi-language-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconMultiLanguage
});
export const CosmosIconMute = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-mute-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconMute
});
export const CosmosIconMyLocation = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-my-location-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconMyLocation
});
export const CosmosIconNews = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-news-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconNews
});
export const CosmosIconNoData = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-no-data-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconNoData
});
export const CosmosIconPagination = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-pagination-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconPagination
});
export const CosmosIconPaginationFilled = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-pagination-filled-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconPaginationFilled
});
export const CosmosIconParcel = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-parcel-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconParcel
});
export const CosmosIconPartnerProfile = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-partner-profile-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconPartnerProfile
});
export const CosmosIconPaste = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-paste-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconPaste
});
export const CosmosIconPause = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-pause-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconPause
});
export const CosmosIconPayment = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-payment-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconPayment
});
export const CosmosIconPersonFollow = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-person-follow-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconPersonFollow
});
export const CosmosIconPersonFollowing = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-person-following-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconPersonFollowing
});
export const CosmosIconPersonProfileFilled = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-person-profile-filled-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconPersonProfileFilled
});
export const CosmosIconPhone = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-phone-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconPhone
});
export const CosmosIconPhotoCamera = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-photo-camera-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconPhotoCamera
});
export const CosmosIconPhotoCameraReverse = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-photo-camera-reverse-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconPhotoCameraReverse
});
export const CosmosIconPictureInPicture = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-picture-in-picture-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconPictureInPicture
});
export const CosmosIconPinterest = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-pinterest-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconPinterest
});
export const CosmosIconPlay = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-play-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconPlay
});
export const CosmosIconPlaylist = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-playlist-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconPlaylist
});
export const CosmosIconPlaylistPersonalised = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-playlist-personalised-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconPlaylistPersonalised
});
export const CosmosIconPlus = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-plus-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconPlus
});
export const CosmosIconPodcast = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-podcast-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconPodcast
});
export const CosmosIconPresentation = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-presentation-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconPresentation
});
export const CosmosIconPreview = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-preview-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconPreview
});
export const CosmosIconPreviewFilled = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-preview-filled-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconPreviewFilled
});
export const CosmosIconPreviewOff = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-preview-off-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconPreviewOff
});
export const CosmosIconProductPlacement = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-product-placement-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconProductPlacement
});
export const CosmosIconQuality = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-quality-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconQuality
});
export const CosmosIconQuiz = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-quiz-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconQuiz
});
export const CosmosIconRadioButton = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-radio-button-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconRadioButton
});
export const CosmosIconRedeem = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-redeem-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconRedeem
});
export const CosmosIconRedo = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-redo-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconRedo
});
export const CosmosIconReload = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-reload-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconReload
});
export const CosmosIconReminderFalse = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-reminder-false-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconReminderFalse
});
export const CosmosIconReminderTrue = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-reminder-true-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconReminderTrue
});
export const CosmosIconRemove = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-remove-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconRemove
});
export const CosmosIconRendition = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-rendition-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconRendition
});
export const CosmosIconReplay = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-replay-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconReplay
});
export const CosmosIconReplay30 = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-replay30-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconReplay30
});
export const CosmosIconReplay5 = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-replay5-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconReplay5
});
export const CosmosIconReport = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-report-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconReport
});
export const CosmosIconResults = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-results-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconResults
});
export const CosmosIconRokuReplay = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-roku-replay-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconRokuReplay
});
export const CosmosIconRules = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-rules-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconRules
});
export const CosmosIconSave = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-save-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconSave
});
export const CosmosIconSaveFalse = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-save-false-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconSaveFalse
});
export const CosmosIconSaveTrue = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-save-true-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconSaveTrue
});
export const CosmosIconScreenRotation = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-screen-rotation-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconScreenRotation
});
export const CosmosIconSearch = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-search-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconSearch
});
export const CosmosIconSeason = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-season-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconSeason
});
export const CosmosIconSecure = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-secure-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconSecure
});
export const CosmosIconSelectAll = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-select-all-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconSelectAll
});
export const CosmosIconSettings = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-settings-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconSettings
});
export const CosmosIconShare = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-share-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconShare
});
export const CosmosIconShareFacebook = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-share-facebook-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconShareFacebook
});
export const CosmosIconShareMessenger = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-share-messenger-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconShareMessenger
});
export const CosmosIconShareReddit = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-share-reddit-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconShareReddit
});
export const CosmosIconShareTab = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-share-tab-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconShareTab
});
export const CosmosIconShareTwitterFilled = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-share-twitter-filled-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconShareTwitterFilled
});
export const CosmosIconShareVk = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-share-vk-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconShareVk
});
export const CosmosIconShareWhatsapp = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-share-whatsapp-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconShareWhatsapp
});
export const CosmosIconShop = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-shop-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconShop
});
export const CosmosIconShoppingBag = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-shopping-bag-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconShoppingBag
});
export const CosmosIconShow = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-show-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconShow
});
export const CosmosIconSidebarOff = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-sidebar-off-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconSidebarOff
});
export const CosmosIconSidebarOn = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-sidebar-on-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconSidebarOn
});
export const CosmosIconSignUp = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-sign-up-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconSignUp
});
export const CosmosIconSizeContract = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-size-contract-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconSizeContract
});
export const CosmosIconSizeExpand = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-size-expand-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconSizeExpand
});
export const CosmosIconSkipNext = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-skip-next-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconSkipNext
});
export const CosmosIconSkipPrevious = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-skip-previous-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconSkipPrevious
});
export const CosmosIconSnapchat = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-snapchat-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconSnapchat
});
export const CosmosIconSneaker = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-sneaker-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconSneaker
});
export const CosmosIconSongkick = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-songkick-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconSongkick
});
export const CosmosIconSortAZ = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-sort-az-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconSortAZ
});
export const CosmosIconSortZA = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-sort-za-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconSortZA
});
export const CosmosIconSoundcloud = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-soundcloud-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconSoundcloud
});
export const CosmosIconSpotify = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-spotify-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconSpotify
});
export const CosmosIconStar = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-star-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconStar
});
export const CosmosIconStarFilled = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-star-filled-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconStarFilled
});
export const CosmosIconStarred = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-starred-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconStarred
});
export const CosmosIconStarredFilled = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-starred-filled-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconStarredFilled
});
export const CosmosIconStart = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-start-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconStart
});
export const CosmosIconStop = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-stop-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconStop
});
export const CosmosIconStory = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-story-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconStory
});
export const CosmosIconStrava = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-strava-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconStrava
});
export const CosmosIconSubmit = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-submit-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconSubmit
});
export const CosmosIconSubtitles = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-subtitles-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconSubtitles
});
export const CosmosIconSubtitlesFilled = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-subtitles-filled-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconSubtitlesFilled
});
export const CosmosIconSuccess = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-success-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconSuccess
});
export const CosmosIconTShirt = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-t-shirt-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconTShirt
});
export const CosmosIconTablet = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-tablet-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconTablet
});
export const CosmosIconTeam = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-team-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconTeam
});
export const CosmosIconTextFormat = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-text-format-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconTextFormat
});
export const CosmosIconThumbsDown = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-thumbs-down-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconThumbsDown
});
export const CosmosIconThumbsUp = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-thumbs-up-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconThumbsUp
});
export const CosmosIconTiktok = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-tiktok-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconTiktok
});
export const CosmosIconTiktokDark = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-tiktok-dark-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconTiktokDark
});
export const CosmosIconTiktokLight = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-tiktok-light-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconTiktokLight
});
export const CosmosIconTrailer = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-trailer-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconTrailer
});
export const CosmosIconTrending = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-trending-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconTrending
});
export const CosmosIconTrophy = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-trophy-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconTrophy
});
export const CosmosIconTv = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-tv-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconTv
});
export const CosmosIconTwitch = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-twitch-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconTwitch
});
export const CosmosIconUpload = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-upload-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconUpload
});
export const CosmosIconUser = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-user-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconUser
});
export const CosmosIconUserFilled = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-user-filled-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconUserFilled
});
export const CosmosIconUserSettings = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-user-settings-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconUserSettings
});
export const CosmosIconVerified = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-verified-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconVerified
});
export const CosmosIconVideo = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-video-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconVideo
});
export const CosmosIconViewMore = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-view-more-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconViewMore
});
export const CosmosIconVimeo = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-vimeo-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconVimeo
});
export const CosmosIconVine = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-vine-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconVine
});
export const CosmosIconVolume = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-volume-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconVolume
});
export const CosmosIconVolumeDown = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-volume-down-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconVolumeDown
});
export const CosmosIconVolumeLow = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-volume-low-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconVolumeLow
});
export const CosmosIconVolumeMid = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-volume-mid-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconVolumeMid
});
export const CosmosIconVolumeUp = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-volume-up-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconVolumeUp
});
export const CosmosIconVote = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-vote-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconVote
});
export const CosmosIconVr = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-vr-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconVr
});
export const CosmosIconWarehouse = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-warehouse-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconWarehouse
});
export const CosmosIconWarning = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-warning-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconWarning
});
export const CosmosIconWashout = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-washout-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconWashout
});
export const CosmosIconWatch = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-watch-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconWatch
});
export const CosmosIconYoutube = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-youtube-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconYoutube
});
export const CosmosIconZoomIn = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-zoom-in-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconZoomIn
});
export const CosmosIconZoomOut = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-icon-zoom-out-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosIconZoomOut
});
export const CosmosImage = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-image-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosImage
});
export const CosmosLink = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-link-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosLink
});
export const CosmosMediaPreview = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-media-preview-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosMediaPreview
});
export const CosmosMode = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-mode-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosMode
});
export const CosmosPersonCard = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-person-card-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosPersonCard
});
export const CosmosProductCard = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-product-card-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosProductCard
});
export const CosmosRadio = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-radio-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosRadio
});
export const CosmosSpinner = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-spinner-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosSpinner
});
export const CosmosStoryCard = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-story-card-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosStoryCard
});
export const CosmosText = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-text-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosText
});
export const CosmosTitle = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-title-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosTitle
});
export const CosmosTooltip = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-tooltip-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosTooltip
});
export const CosmosVideoCard = /*@__PURE__*/ createReactComponent({
    tagName: 'cosmos-video-card-2-72-1',
    defaultProps: {},
    defineCustomElement: defineCosmosVideoCard
});
